import { css } from 'styled-components';

export const sectionShell = css`
  position: relative;
  padding: 96px 24px;
  display: flex;
  justify-content: center;
  background: var(--background);
  border-top: 1px solid var(--border);
  @media (max-width: 768px) { padding: 64px 20px; }
`;

export const sectionHeader = css`
  width: 100%;
  max-width: 740px;
  align-self: flex-start;
  text-align: left;
`;

export const sectionTitle = css`
  margin: 0;
  color: var(--text);
  font-family: 'Instrument Sans', system-ui, sans-serif;
  font-size: clamp(32px, 4vw, 46px);
  line-height: 1.12;
  font-weight: 650;
  letter-spacing: -0.04em;
`;

export const sectionDescription = css`
  max-width: 680px;
  margin: 18px 0 0;
  color: var(--muted);
  font-size: 17px;
  line-height: 1.7;
  font-weight: 400;
`;
